import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LoadingDot from '../../../func/components/loading/LoadingDot';

interface Props {
  noticeList: {
    name: string;
    title: string;
    branch: string;
    deletebtn: string;
    writetime: string;
    articleidx: number;
    commentcount: number;
  }[];
  isLoading: boolean;
}

function Announcement({ noticeList, isLoading }: Props) {
  const navigate = useNavigate();
  return (
    <Section>
      <Inner>
        <Content
          onClick={() => {
            if (isLoading) return;
            navigate(`/board/detail/${noticeList[0].articleidx}`);
          }}
        >
          <img src="/assets/images/icon/megaphone-red.svg" alt="" />
          <Context>
            {isLoading ? (
              <LoadingDot size={10} />
            ) : noticeList.length > 0 ? (
              noticeList[0].title
            ) : (
              '공지사항이 없습니다.'
            )}
          </Context>
        </Content>
        <ViewMoreButton onClick={() => navigate('/board')}>
          전체보기
          <img src="/assets/images/arrow/arrow-right-gray-small.svg" alt="" />
        </ViewMoreButton>
      </Inner>
    </Section>
  );
}

export default Announcement;

const Section = styled.div`
  padding: 12px 16px 0 16px;
`;

const Inner = styled.div`
  display: flex;
  gap: 6px;
  align-self: stretch;
  border-radius: 4px;
  align-items: center;

  &:active {
    background: rgba(2, 32, 71, 0.05);
    box-shadow: 0 2px 10px 0 rgba(220, 228, 232, 0.3);
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
`;

const Context = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.26px;

  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ViewMoreButton = styled.div`
  display: flex;
  padding: 1px 0;
  align-items: center;
  gap: 2px;
  white-space: nowrap;

  color: #4e5968;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
